import { call, put } from "redux-saga/effects";
import axios from "../../axiosConfig";
import { UPLOAD_BANNER_IMAGE_FAILED,UPLOAD_BANNER_IMAGE_SUCCESS } from "../Actions/HtmlBannerActions";
import { TOAST_SHOW } from "../Actions/ToastAction";

export function* uploadBannerImageSaga(action: any): unknown {
    try {
         const response = yield call(axios.post, `/uploadHtmlBannerImage`, action.payload);
        const { data, status } = response 

        if (status === 200) {
            yield put({ type: UPLOAD_BANNER_IMAGE_SUCCESS, payload: data });
            yield put({
                type: TOAST_SHOW,
                payload: { message: 'Image uploaded successfully!', severity: 'Success', show: true },
            });
        }

    } catch (e: any) {
        yield put({ type: UPLOAD_BANNER_IMAGE_FAILED, payload: [] });
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
}